import { useQuery } from "@origin-digital/query";
import { ICategoryWithArticlesDataDto } from "../contract";
import { fetchCategoryArticles } from "../services/categories";
import { toError, useShouldThrowQueryError } from "./useShouldThrowQueryError";

export interface UseCategoryArticlesResult {
  data: ICategoryWithArticlesDataDto | null;
  loading: boolean;
  error: Error | null;
}

export const useCategoryArticles = (
  slug: string | undefined
): UseCategoryArticlesResult => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["category", slug],
    queryFn: () => {
      if (!slug) {
        throw new Error("Category slug is required");
      }
      return fetchCategoryArticles(slug);
    },
    staleTime: 0,
    enabled: Boolean(slug),
  });

  const categoryArticlesError = toError(error);
  useShouldThrowQueryError(categoryArticlesError, {
    component: "useCategory",
    action: "fetchCategoryArticles",
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: categoryArticlesError,
  };
};
